ixModuleRouting("impactx.scheduler", {
    "/schedulerlist": {
        template: "<ixa-scheduler-list></ixa-scheduler-list>",
        process: "ListScheduler",
        workspace: "admin",
    },
    "/scheduler/:id": {
        template: "<ixa-scheduler-detail></ixa-scheduler-detail>",
        templateUrl: "modules/scheduler/templates/scheduler.html",
        process: "EditScheduler",
        controller: "SchedulerCtrl",
        controllerAs: "schedulerCtrl",
        workspace: "admin",
    },
});
